import { lazy } from 'react'

export const Sugar = lazy(() => import('./Sugar'))
